<template>
	<Container ref='root' :customer='showCustomer' @colseCustomer='showCustomer=false'>
		<TopBar />
		<div class='load' v-show='showLoading'>
			<loading />
		</div>
		<div class="cartPage" v-if='!showLoading'>
			<Alert class="toPc" type="info" v-if='false'>
				想省&nbsp;<span>${{difference}}</span>&nbsp;&nbsp;<Button class="goto" type="primary" @click="goto">快来成为优惠顾客吧</Button>
				<template slot="desc"></template>
			</Alert>
			<!-- 选中仓库 -->
			<div class='warehouse'>
				运送方式(Shipping Method:
				<Button class='selectWarehouse' type="primary" @click="warehouseOpen=true" ghost>
					<template v-if='!default_store.Code'>
						请选择配送方式
					</template>
					<template v-else>
						{{default_store.Name}}( {{default_store.Code=='501'?'Package Deliver':'Pick up Station'}})
					</template>
				</Button>
			</div>
			<!-- 地址标题 -->
			<div class='addressTitle' v-if='getVipNo'>
				<b>选择收货地址</b>
				<Button class='addAddress' type="primary" @click='addAddress' ghost>新增收货地址</Button>

			</div>
			<!-- 地址 -->
			<div id='Anchor_props' class='address transition_dom' v-if='getVipNo&&!isMobile'>
				<template v-for='(address,index) in sortaddresse'>
					<div class="item" v-show='!isAllAddress?index<=3:true' :saa='index' :key="address.id" :class='{select:(address.id==qchoosedAddress.id),hover:(address.id==hoverActive)}' v-on:click.stop='chooseAddress(address)' @mouseenter='hoverActive=address.id' @mouseleave="hoverActive=-1">
						<div class="left">
							<span class="name">{{address.name}}</span>
							<span class="tel">{{address.moblie_phone}}</span>
							<Tag v-if="address.is_default" class="addressTag" color="#B176C5">默认地址</Tag>
							<p>
								<i v-if='IconText(address.tag_type)' :style="{color: iconColor(address.tag_type)}" v-text='IconText(address.tag_type)'></i>
								{{address.province}}&nbsp;&nbsp;{{address.city}}&nbsp;&nbsp;{{address.county}}&nbsp;&nbsp;{{address.town}}&nbsp;&nbsp; {{address.street}}&nbsp;&nbsp;
							</p>
						</div>
						<div class="right" v-show='address.id==hoverActive'>
							<!-- <Icon type="ios-paper-outline" size='20' color='#B176C5' /> &nbsp;
                        <Icon type="ios-trash-outline" size='20' color='#B176C5' /> -->
							<img title="编辑地址" src="@/assets/edit.png" v-on:click.stop='modifyAddress(address)'>
							&nbsp;
							<img title="删除地址" src="@/assets/del.png" v-on:click.stop='cdeleteAddress(address)'>
						</div>
					</div>
				</template>
			</div>
			<div id='Anchor_props' class='address transition_dom' v-else-if="isMobile&&getVipNo">
				<template v-for='(address,index) in sortaddresse'>
					<div class="item" v-show='!isAllAddress?index<=3:true' :saa='index' :key="address.id" :class='{select:(address.id==qchoosedAddress.id),hover:(address.id==hoverActive)}' v-on:click.stop='chooseAddress(address)'>
						<div class="left">
							<span class="name">{{address.name}}</span>
							<span class="tel">{{address.moblie_phone}}</span>
							<Tag v-if="address.is_default" class="addressTag" color="#B176C5">默认地址</Tag>
							<p>
								<i v-if='IconText(address.tag_type)' :style="{color: iconColor(address.tag_type)}" v-text='IconText(address.tag_type)'></i>
								{{address.province}}&nbsp;&nbsp;{{address.city}}&nbsp;&nbsp;{{address.county}}&nbsp;&nbsp;{{address.town}}&nbsp;&nbsp; {{address.street}}&nbsp;&nbsp;
							</p>
						</div>
						<div class="right" v-show='address.id==hoverActive'>
							<!-- <Icon type="ios-paper-outline" size='20' color='#B176C5' /> &nbsp;
                        <Icon type="ios-trash-outline" size='20' color='#B176C5' /> -->
							<img title="编辑地址" src="@/assets/edit.png" v-on:click.stop='modifyAddress(address)'>
							&nbsp;
							<img title="删除地址" src="@/assets/del.png" v-on:click.stop='cdeleteAddress(address)'>
						</div>
					</div>
				</template>
			</div>

			<span v-if='addresses.length > 4' class="showAllAddr" @click='operating'>{{isAllAddress?'收起地址':'显示全部地址'}}&nbsp;<b>&gt;</b></span>
			<!-- 产品列表 -->
			<div class="productList">
				<div cellspacing="0">
					<div class="product product-header">
						<div class="p-checkbox"><Checkbox size='small' @on-change="allCarSel" v-model="allSel"></Checkbox>全选</div>
						<div class="p-name" style="padding-left:10px;">产品信息</div>
						<div class="price">单价</div>
						<div class='count'>数量</div>
						<div class='sub-total'>小计</div>
						<div class='sub-total'>点数兑换</div>
					</div>
					<template v-for="(products,productindex) in menuList" >
						<div :id='products.sku' class="product" :key="products.sku" :style="{borderBottom:purchaseEvent && purchaseEvent[products.sku] ? 'none':'1px solid #eaeaea'}">
							<div class="p-checkbox">
								<Checkbox size='small' @on-change="carSel(products.sku)" v-model="cartCheck[products.sku]"></Checkbox>
							</div>
							<div class="p-name">
								<div class="p-left">
									<div  class="p-img" style="cursor: pointer;" @click="goDetail(products)">
										<img class="img" src="@/assets/order/errorImg2.png" v-real-img="products.image_path_big">
									</div>
								</div>
								<div class="p-right">
										<div class="p-name1">
									<div style="cursor: pointer;" class="p-name-span" @click="goDetail(products)">
										<span class='span_name'> {{products.name}}</span>
										<div class='hotlist'>
											<span v-if='products.is_hot == 1' class="hot">热销<b class='no_mobile'>(Hot)</b></span>
											<template v-if='products.is_hot == 1'>&nbsp;</template>
											<span v-if='products.is_new == 1' class="hot">新品<b class='no_mobile'>(New)</b></span>
											<template v-if='products.is_new == 1'>&nbsp;</template>
											<span v-if='products.is_promotion == 1' class="hot">促销<b class='no_mobile'>(Promotion)</b></span>
										</div>
									</div>

									<!-- <template v-if="isExchange(products)&&!isMobile">
										<select-point :products='products' :poinBalance='poinBalance' @showChoosePTList="showChoosePTList"></select-point>
									</template> -->

								</div>
								<div class="other">
									<span v-if="isOriginalPrice==false">点数: {{products.specproducts[0].pv}}</span>
									<span>{{products.specproducts[0].specs[0].name}}: {{products.specproducts[0].specs[0].value}}</span>
									<span v-if="products.specproducts[0].pt>0 && isOriginalPrice==false">PT: {{products.specproducts[0].pt}}</span>
								</div>
								<template v-if='!isExchange(products)&&!isMobile'>
									<!-- <section class='select_pt_no'><span>点数兑换<div class="no_mobile">Point Redeem</div></span></section> -->
								</template>
								</div>
							
							</div>
							<div class="price">{{isPVOriginalPrice?products.specproducts[0].original_price:products.specproducts[0].price}}</div>
							<div class="count">
								<template v-if='noStockText(products)'>
									<!-- <span class='show_nostock'>仅快递<em class="no_mobile">(Only Delivery)</em></span> -->
									<span class='show_nostock' v-html="noStockText(products)"></span>
									<span class='delete' @click='deleteProduct(products)'>删除(Del)</span>
								</template>
								<div :class="{'offset':isExchange(products)&&isMobile } " v-else>
									<template v-if='isMobile'>
										<buyCart v-model="products.num" :iscart='2' :product="products" class='products_add' style='display:inline-block' @showPromoCode='showPromoCode'></buyCart>
									</template>
									<template v-else>
										<buyCart v-model="products.num" :product="products" style='display:inline-block' @showPromoCode='showPromoCode'></buyCart>
									</template>
									<div class="point_mobile" v-if='isMobile'>
										<template v-if="isExchange(products)">
											<select-point :products='products' :poinBalance='poinBalance' @showChoosePTList="showChoosePTList"></select-point>
										</template>
										<template v-else>
											<!-- <section class='select_pt_no'><span>点数兑换</span></section> -->
										</template>
									</div>

									<!-- <buyCart v-model="products.num" :product="products" style='display:inline-block'></buyCart> -->
								</div>

							</div>
							<!-- <div class='sub-dh no_mobile'>{{isNaN(products.point / products.pt)?0:products.point / products.pt}}</div> -->
							<div class="sub-total no_mobile">￥{{((isPVOriginalPrice?products.specproducts[0].original_price:products.specproducts[0].price)*(products.num-(isNaN(products.point / products.pt)?0:products.point / products.pt))).toFixed(2)}}</div>
							<div class="sub-point no_mobile">
								<template v-if="isExchange(products)&&!isMobile">
									<select-point :products='products' :poinBalance='poinBalance' @showChoosePTList="showChoosePTList"></select-point>
								</template>
							</div>
						</div>
						<topup-purchase-panel
							:key="products.sku"
							v-if='purchaseEvent && purchaseEvent[products.sku] && cartCheck[products.sku]' 
							:purchaseEvent='purchaseEvent[products.sku]'
							:isOriginalPrice='isOriginalPrice' 
							:isPVOriginalPrice='isPVOriginalPrice'
							:noStockText='noStockText'
							:isExchange='isExchange'
							:isMobile='isMobile'
							:poinBalance='poinBalance'
							:default_store_id='default_store_id'
						/>
					</template>
					
					<template v-for="(products,productindex) in promoteList.filter(item=>item.promote_mode!='combine')" v-if="products.control!=-1">
						<PromoteItem
						:products='products'
						@reSelectPromote='reSelectPromote'
						:key="products.sku"
						/>
					</template>
					<template v-for="(products,productindex) in promoteList.filter(item=>item.promote_mode=='combine')" v-if="products.control!=-1 && products.cust_current_giftskunum < products.max_num">
						<template v-for='optional in products.optionals'>
							<PromoteItem
								:products='optional'
								@reSetPromote='reSetPromote'
								:control = 'products.control'
								:storeId='default_store_id'
								:key="products.sku"
							/>
						</template>
					</template>
				</div>
			</div>
			<!-- 价格显示区域 -->
			<div class="gather">
				<div class='gather-left'>
					<div class="element total-price">
						<span class="name">产品总价(Product Total Price):</span>
						<span class="value">￥{{cartPrice.total_product_amount.toFixed(2)}}</span>
					</div>
					<div class="element total-pv" v-if='showCoupons'>
						<span @click="openCoupon" class="name">使用优惠券:
							<!-- <img class='tip-doubt' src="http://doc.doterra.cn/uploads/global/doubt.png"> -->
							<b style="color: #BD8BCA;text-decoration: underline;">(共有{{validCoupons.length}}张)</b>
						</span>
						<div class="value" style="width: initial;">
							<stepper :value='usedCouponCodes.length' @input='modifyCoupon' :min='0'/>
							<div class='coupon-money' v-if='couponMoney'>-{{couponMoney.toFixed(2)}}</div>
						</div>
					</div>
					<div class="element total-pt">
						<span @click="oepnDoubt('Tips_PV')" class="name">产品总点数(Product Total PV):
							<img class='tip-doubt' src="http://doc.doterra.cn/uploads/global/doubt.png">
						</span>
						<span class="value">{{cartPrice.total_pv.toFixed(2)}}</span>
					</div>
					<div class="element total-pv ar" v-if='getVipNo && !hideNewCustomerCell'>
						<span @click="oepnDoubt('Tips_Redeem_Point')" class="name">兑换点数(Redeem Point):
							<img class='tip-doubt' src="http://doc.doterra.cn/uploads/global/doubt.png">
							<b>(余:{{ptRealBalance.toFixed(2)}})</b>
						</span>
						<span class="value">{{cartPrice.total_change_point.toFixed(2)}} </span>
					</div>
					<div class="element total-fee" v-if='getVipNo'>
						<span @click="oepnFreightDoubt('Tips_Free_Freight')" class="name">配送费(Freight):<span style='font-size:13px' v-if='lrp_text'>{{lrp_text}}</span>
							<img class='tip-doubt' src="http://doc.doterra.cn/uploads/global/doubt.png">
						</span>
						<div class="value">
							<div class="mdeliveryFemv" v-if='finalFree>0&&!isMerge'>
								<div style="color: rgb(255, 70, 29);border-color: rgb(255, 70, 29);">
									<p style="color: rgb(255, 70, 29);">免{{finalFree.toFixed(2)}}</p>
								</div>
							</div>
							<span class="ellipsis" :class="{add_x: finalFree > 0&&!isMerge, move_x:(deliveryFee)>0}" style="width:initial" v-text='resuldeliveryFee()'></span>
						</div>

					</div>

					<div class="element ar" v-if='getVipNo && !hideNewCustomerCell'>
						<span @click="oepnDoubt('Tips_Product_Credits')" class="name">产品积分支付(Product Credits):<img class='tip-doubt' src="http://doc.doterra.cn/uploads/global/doubt.png">
							<b>(余:{{arRealBalance.toFixed(2)}})</b></span>
						<div class="value">
							<input ref='arInputRef' style='height:24px;width:80px;' v-model="arValue" @blur="setOtherCar" placeholder='产品积分'>
							<div @click='showArTip' class="mask" v-if='cartPrice.total_change_point'></div>
						</div>
					</div>
					<!-- <div class="element ar" v-if='getVipNo'>
						<span @click="oepnDoubt('Tips_Redeem_Point')" class="name">点数余额(Point Balance):<img class='tip-doubt' src="http://doc.doterra.cn/uploads/global/doubt.png">
							<b>(余:{{poinBalance.toFixed(2)}})</b></span>
						<span class="value">{{cartPrice.total_change_point.toFixed(2)}}</span>
					</div> -->
					<div class="element balance" v-if='getVipNo&&abshow&&!hideNewCustomerCell'>
						<span @click="oepnDoubt('Tips_Product_AB')" class="name">账户余额支付(Account Balance):<img class='tip-doubt' src="http://doc.doterra.cn/uploads/global/doubt.png">
							<b>(余:{{realBalance.toFixed(2)}})</b></span>
						<span class="value"><input style='height:24px;width:80px;' v-model="abValue" @blur="setOtherCar" placeholder='账户余额'></span>
					</div>

					<div class="element total-amount">
						<span class="name">应支付金额(SubTotal):</span>
						<span class="value">￥{{payFee}}</span>
					</div>
					<div class="element lapsePv" v-if='getVipNo && !hideNewCustomerCell'>
						<span class="name">三个月内即将过期点数:</span>
						<span class="value">{{expiryPoint}}
							&nbsp;&nbsp;
							<a class='lapseMore' @click="expiryMore">更多</a>
						</span>
					</div>

					<div class="element merge" v-if='mergeShow'>
						<span class="name" v-if='mergeVisiable'>
							<Checkbox size='small' :value="isMerge" @input="()=>triggerMerge()" >{{mergeData.title}}:</Checkbox><img style="cursor: pointer;" class='tip-doubt' @click="oepnDoubt('Tips_Product_Merge')" src="http://doc.doterra.cn/uploads/global/doubt.png">
							<!-- <b style="cursor: pointer;" @click="oepnDoubt('Tips_Product_Merge')">{{mergeData.subTitle}}</b> -->
						</span>
					</div>
					<div class="element merge" v-if='mergeShow'>
						<span class="name">
							<b style="cursor: pointer;" @click="oepnDoubt('Tips_Product_Merge')">{{mergeData.subTitle}}</b>
						</span>
					</div>
					<div v-if='showLrpSet'>
						<div class='setlrp'>
							<Checkbox v-model='lrp_flag' size="large" style="margin-top:15px;display:block;text-align: left;">我愿意参加忠诚顾客回馈计划轻松购（LRP）</Checkbox><img style="cursor: pointer;" @click="gowhatLRP" src="http://doc.doterra.cn/uploads/global/doubt.png">
						</div>
						<div class='lrp-date' v-if='lrp_flag'>
							<div>
								每月
								<Select v-model="lrp_reminder" size="small" style="width:50px" placement='top'>
									<Option v-for='n in 25' v-if='n!=15' :key="n" :value="n">{{ n }}</Option>
								</Select>
								日，LRP轻松购提醒
							</div>
							<div style='margin-left: 10px;'>
								<i-switch v-model="isLRP" color='#4cda63'/>
							</div>
						</div>
						
					</div>
				</div>
				<div class='gather-right'>
					<div>
						<Button :disabled='settlementLoad||continueLoad' class='cleanBtn' type='primary' @click='cleanCart'>清除购物车<b>Clean Cart</b></Button>
						<i class='btnW'></i>
						<Button :loading="continueLoad" :disabled='settlementLoad' class='gobuy' type='primary' @click='confirmLoad(1)'>继续购物<b>Go on Shop</b></Button>
					</div>
					<Button :loading="settlementLoad" :disabled='continueLoad' class='confirm' type='primary' @click='confirmLoad1' size='large' long>进行结账 <b>Proceed to Checkout</b></Button>
				</div>
			</div>
		</div>
		<Warehouse :show='warehouseOpen' :storeId='default_store_id' @confirm='selectStore' @cancel='warehouseOpen=false' />
		<editAddressView :title="editAddress.id>0?'编辑地址(Edit address)':'新增地址(New address)'" :editAddress='editAddress' :show='show' @confirm='handleConfirm' @cancel='handleCancel' :loading='loading'></editAddressView>

		<Modal title="生日专属礼遇" v-model="BHshow" :closable="false" :mask-closable="false">
			<div class='main-bh'>
				<p class='tip' :class='{highlight:BHerror_text}'><b>温馨提示&nbsp;:&nbsp;</b>至多输入20位英文字母，大小写不限，不可输入特殊字符。(例:May Wu)</p>
				<Input v-model.trim="BHtext" :class='{error:BHerror_input}' placeholder="请填写您需要定制的生日礼遇专属文字"></Input>
			</div>
			<div slot="footer">
				<button @click="BHscancel" type="button" class="ivu-btn ivu-btn-text ivu-btn-large"> <span>不刻字(No lettering)</span></button>
				<button @click="confirmLoad(2)" type="button" class="ivu-btn ivu-btn-primary ivu-btn-large"><span>刻字(Lettering)</span></button>
			</div>
		</Modal>
		<newCustomer :value='newValue' :isCart='true' @close='close' @login='goLogin' />
		<PromoCode :product='PromoModel' :show='PromoModelShow' :opType='PromoModelType' @showPromoCode='showPromoCode'></PromoCode>
		<Modal v-model='showReSelect' @on-ok='confirmOptionalPromote'>
			<div slot='header'>切换赠品</div>
			<div class="products" >
				<div v-if='mutexPromoteTip[0]' v-html='mutexPromoteTip[0]'></div>
				<div class='optional-product' v-for='(item,index) in optionalPromotes' :key='index' @click='optionalProduct = item'>
					<div class='radio-box'><Radio size='large' :value='optionalProduct.sku == item.sku'></Radio></div>
					<img :src="item.image_path_big" alt="">
					<div>
						<p class="title">{{item.name}}</p>
						<p class="description">{{item.description}}</p>
					</div>
				</div>
				<div v-if='mutexPromoteTip[1]' v-html='mutexPromoteTip[1]'></div>
			</div>
		</Modal>
		<CombinePromoteModal ref='combineModal'/>
		<couponsView 
			ref='couponsView' 
			:coupons='coupons' 
			:usedCoupons='usedCouponCodes' 
			@triggerCoupon='triggerCoupon'
			@onCancelCoupons='confirmCoupon'
		/>
		<div class='purchaseModal' v-if="showPurchaseModal">
			<div class="content">
				<div class='main-bh'>
					<div style='text-align:center;' v-html='purchaseModalContent'></div>
				</div>
				<div class='p-footer'>
					<button style='flex:1' @click="showPurchaseModal = false" type="button" class="ivu-btn ivu-btn-text ivu-btn-large"> <span>取消</span></button>
					<div style='width:1px;height:40px;background-color:#E8EAEC;'></div>
					<button style='flex:1;color:#BD8BCA' @click="scrollToPurchase" type="button" class="ivu-btn  ivu-btn-text  ivu-btn-large"><span>去加购</span></button>
				</div>
			</div>
		</div>
	</Container>
</template>

<script>
import { api_methods } from "@/service/loadData";
import TopBar from "@/components/common/TopBar";
import selectPoint from "@/components/order/selectPoint";
import buyCart from "@/components/order/buyCart";
import loading from "@/components/order/loading";
import Warehouse from "@/components/order/warehouse";
import editAddressView from "@/components/order/editAddressView";
import CombinePromoteModal from "@/components/order/CombinePromoteModal";
import newCustomer from "@/components/order/NewCustomer";
import PromoCode from "@/components/order/PromoCode";
import PromoteItem from "@/components/order/PromoteItem";
import TopupPurchasePanel from './components/TopupPurchasePanel'
import util from "@/config/util";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import {
	systemConfigMethods,
	cartInfoMethods,
	userInfoOrderMethods,
	promoCodeMethods,
	addressMethods,
	promoteMethods,
	productLimtMethods,
	getImgPath,
	couponsMixin,
} from "@/components/common/mixin";
import { cvoUrl } from "@/config/env";
import stepper from './components/stepper'
import couponsView from '@/components/order/couponsView'
import { pc_pv_threshold } from '@/common/constant'
export default {
	data() {
		return {
			showReSelect:false,
			optionalPromotes:[],
			optionalProduct:{},
			isAllAddress: false,
			choosedProducts: null, //当前选中兑换商品
			showPTChange: false,
			continueLoad: false,
			settlementLoad: false,
			showLoading: true,
			warehouseOpen: false,

			LRPNum: null,

			addresses: [],
			doubtKey: {},
			freightTip:{},
			productList: {}, //所有产品集合

			arBalance: 0.0,
			poinBalance: 0.0,
			expiryPoint: 0.0,
			balance: 0.0,
			arValue: 0,
			abValue: 0,
			hoverActive: -1,

			BHshow: false,
			BHtext: null,
			BHerror_text: null,
			BHerror_input: null,

			initaddresH: null,
			mobileMode: false,
			newValue: false,
			userBalance: [],
			abshow: false,
			mergeData: {},
			showCustomer:false,
			allSel:true,
			noBirthday:'2022-11-01',
			birthdayStart:'2021-11-01',

			//当前选中大会code
			PromoModel: null,
			PromoModelShow: false,
			PromoModelType:null,

			// 设定LRP
			lrp_flag:true,
			isLRP:true,
			lrp_reminder: 10, 
			firstLoadPromote:true,
			showFreeFreight:util.realNowTime() < new Date(2022,3,1),
			pickResolve:null,
			mutexPromoteTip:[],
			bogoConfig:{
				bogoSkus:[],
				freightConfig:{},
			},
			// 是否显示加价购提醒弹窗
			showPurchaseModal:false,
			purchaseModalContent:'',
			mainSku:'',
			mergeVisiable:true
		};
	},
	created() {
		this.$nextTick(function () {
			if (document.documentElement.clientWidth < 1090) {
				this.mobileMode = true;
			}
			this.initData();
		});
	},
	mounted() {},
	watch: {
		promoteList(cur,old){
			if (this.firstLoadPromote) {
				this.firstLoadPromote = false
				this.checkCombinePromote()
				this.checkMutexPromote()
			}
			
		},
		addresses: function (value, ovalue) {
			if (ovalue && ovalue.length > 0) {
				var change = value.filter(
					(u) => u.id == this.qchoosedAddress.id
				);
				if (change[0]) {
					this.CHOOSE_ADDRESS({
						address: change[0],
						index: 0,
					});
				}
			}
		},
		"cartInfo.value"(cur, old) {
			if (cur && !cur.detail[0]) {
				if (this.orderType != 0) {
					this.$router.push("/order/product");
				} else {
					this.$router.push("/order/product");
				}
			}
			if (!cur) {
				this.$router.push("/order/product");
			}
		},
		payPv: function (value, ovalue) {
			if (!this.showLoading) {
				if (this.isOriginalPrice && this.selfCarNo) {
					if (!this.isPVOriginalPrice && ovalue < pc_pv_threshold) {
						this.setOtherCar();
					} else if (ovalue >= pc_pv_threshold && this.isPVOriginalPrice) {
						this.setOtherCar();
					} else if (ovalue < pc_pv_threshold) {
					}
				} else if (this.newcustomer) {
					if (value > 0 && value < 50) {
						this.showTips(
							"如再购买" +
								(50 - value).toFixed(2) +
								"点,单笔订单满50点,即可获得LRP回馈点数",
							4000
						);
					}
				}
			}
		},
		async 'lrp_flag'(value,oldValue){
			if(oldValue && !value){
				let response = await this.getArticleDetailAction('register_LRP_tip');
				let cancelText = response.ExtStr1?.split(',')[0];
				let confirmText = response.ExtStr1?.split(',')[1];
				this.$Modal.confirm({
					title: '温馨提示(Tip)',
					cancelText: cancelText,
					okText: confirmText,
					content: `${response.Content}`,
					onOk:()=>{
						this.lrp_flag = true
					},
					onCancel:()=>{
						this.lrp_flag = false
					}
				});
			}
		},
	},
	mixins: [
		systemConfigMethods,
		userInfoOrderMethods,
		cartInfoMethods,
		addressMethods,
		promoCodeMethods,
		productLimtMethods,
		promoteMethods,
		getImgPath,
		couponsMixin,
	],
	components: {
		TopBar,
		selectPoint,
		buyCart,
		Warehouse,
		editAddressView,
		loading,
		newCustomer,
		PromoCode,
		PromoteItem,
		CombinePromoteModal,
		stepper,
		couponsView,
		TopupPurchasePanel,
	},
	computed: {
		...mapGetters(["bogo_switch_tip", "getAccessToken", "getVipNo",'getUserId']),
		...mapState({
			sysConfig: (state) => state.common.sysConfig,
			warehouseInfo: (state) => state.order.warehouseInfo,
			productInfo: (state) => state.order.productInfo,
			productStockInfo: (state) => state.order.productStockInfo,
			choosedAddress: (state) => state.order.choosedAddress,
			newpromoCode: (state) => state.order.newpromoCode,
			userInfo: (state) => state.common.wechatUserInfo,
			guestInfo: (state) => state.common.guestInfo,
			forCustomer: (state) => state.order.forCustomer,
			cartInfo: (state) => state.order.cartInfo,
			promote: (state) => state.order.promote,
			productLimt: (state) => state.order.productLimt,
			orderType: (state) => state.order.orderType,
			cartCheck: (state) => state.order.cartCheck,
			balanceRecord: (state) => state.order.balanceRecord,
			checkedMerge:state =>state.order.checkedMerge,
			combinePromote:(state) => state.order.combinePromote,
			purchaseEvent:(state)=> state.order.purchaseEvent,
			purchaseModal:(state)=> state.order.purchaseModal,
			additionalProducts:(state)=> state.order.additionalProducts,
			additionalsMainMap:(state)=> state.order.additionalsMainMap,
		}),
		finalFree(){
			const {free,bogoConfig,cartCheck:checkList,cartInfo} = this
			const config = bogoConfig.freightConfig.web || bogoConfig.freightConfig.universal
			if (config) {
		      const {args, body} = config
		      const freightConfig = new Function(...args, body)
		      return freightConfig({cartInfo:cartInfo.value, bogoConfig, checkList, free})
		    }
		    return free
		},
		isBogoInCart(){
			const {bogoSkus} = this.bogoConfig
			const details = this.cartInfo.value?.detail
			return details?.length && details.findIndex(item => this.cartCheck[item.sku] && item.num > 0 && bogoSkus.includes(item.sku)) != -1
		},
		isMerge(){
			return this.mergeShow && this.checkedMerge && this.isBogoInCart
		},
		mergeShow: function () {
			if (
				this.default_store_id == "501" &&
				// !this.isbirthday &&
				this.mergeData.result
			) {
				return this.isBogoInCart;
			}
			return false;
		},
		hasDefaultAddress () {
			return !!(this.addresses && this.addresses.length && this.addresses.filter(item => item.is_default).length)
		},
		showLrpSet(){
			let lrp_id = this.userInfo.value.lrp_id
			let customer_type = this.userInfo.value.binding.customer_type
			let vip_no = this.userInfo.value.binding.register.vip_no
			return !lrp_id && customer_type.toLowerCase() != 'rt' && !vip_no 
		},
		
		nowDate: function () {
			let Config = this.systemDetail;
			if (Config.now_time) {
				return util.formatDate.dateFromStr(Config.now_time);
			}
			return new Date();
		},
		isMobile() {
			if (document.body.clientWidth <= 768) {
				return true;
			}
			return false;
		},
		isAllSelCart(){
			var cartList = this.shopCart || [];
			var cartCheck = this.cartCheck || {};
			var result=true;
			cartList.forEach((item, index) => {
				if (!cartCheck[item.sku]) {
					result=false
				}
			});
			return result;
		},
		selShopCart() {
			var cartList = this.shopCart || [];
			var cartCheck = this.cartCheck || {};
			var arry = [];
			cartList.forEach((item, index) => {
				if (cartCheck[item.sku]) {
					arry.push(item);
				}
			});
			return arry;
		},
		selfPromoCode(){
			var cartCheck = this.cartCheck || {};
			var promoData=this.firstPromoCode;
			if(promoData){
				if(cartCheck[promoData.exchange_sku]){
					return promoData
				}
			}
			return null
		},
		selffirstOpentoAll(){
			 var item = this.selfPromoCode;
			if (item && item.is_opentoall == 0) {
				return item
			}
			return null;
		},
		rtPrice() {
			let total_price = 0;
			if (this.selShopCart[0]) {
				this.selShopCart.forEach((item, index) => {
					total_price += item.rt_price * item.num;
				});
			}
			return total_price;
		},
		pcPirce() {
			let total_price = 0;
			if (this.selShopCart[0]) {
				this.selShopCart.forEach((item, index) => {
					total_price += item.pc_price * item.num;
				});
			}
			return total_price;
		},
		difference() {
			return (this.rtPrice - this.pcPirce).toFixed(2);
		},
		warehouseList: function () {
			return [...((this.warehouseInfo || {}).value || {})];
		},
		productStock: function () {
			let ret = [...((this.productStockInfo || {}).value || {})];
			return ret;
		},
		qchoosedAddress: function () {
			return this.choosedAddress || {};
		},
		sortaddresse: function () {
			return this.addresses.sort(function (a, b) {
				return b.is_default - a.is_default;
			});
		},
		ptRealBalance:function(){
			if(this.poinBalance<=0) return  this.poinBalance;

			let abInput = this.poinBalance-this.cartPrice.total_change_point;
			return abInput>0?abInput:0;
		},
		arRealBalance: function () {
			if (this.arBalance <= 0) return this.arBalance;

			let abInput = this.arBalance - this.arFee;
			return abInput > 0 ? abInput : 0;
		},
		realBalance: function () {
			if (this.balance <= 0) return this.balance;

			let abInput = this.balance - this.abFee;
			return abInput > 0 ? abInput : 0;
		},
		abFee: function () {
			let df = this.abValue + "";
			df = df.replace(/[^\d.]/g, "");
			df = df.replace(/\.{2,}/g, ".");
			df = df.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
			df = df.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
			if (df.indexOf(".") < 0 && df != "") {
				df = parseFloat(df);
			}
			var ar = this.balance < 0 ? 0 : this.balance;
			if (df > ar) {
				df = ar;
			}
			var resultcashPay = Number(this.abcashPay.toFixed(2));
			if (df > resultcashPay) {
				df = resultcashPay;
			}
			this.abValue = df;
			return df;
		},
		arFee: function () {
			let df = this.arValue + "";
			df = df.replace(/[^\d.]/g, "");
			df = df.replace(/\.{2,}/g, ".");
			df = df.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
			df = df.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
			if (df.indexOf(".") < 0 && df != "") {
				df = parseFloat(df);
			}
			var ar = this.arBalance < 0 ? 0 : this.arBalance;
			if (df > ar) {
				df = ar;
			}
			var resultcashPay = (((this.arcashPay - this.couponMoney) / 3) * 2).toFixed(2);
			if (Number(df) > resultcashPay) {
				df = resultcashPay;
			}
			this.arValue = df;
			return df;
		},
		deliveryFee: function () {
			let df = 0;
			var item = this.selfPromoCode;
			if (item) {				
				df = item.freight;
				
			} else if (this.isMerge) {
				df = 0;
			} else {
				df = this.baseDeliveryFee;
			}
			df = df - this.finalFree;
			df = df > 0 ? df : 0;

			return df;
		},
		//现金待支付金额
		cashPay: function () {
			let df =
				Number(this.cartPrice.total_product_amount) +
				Number(this.deliveryFee) +
				Number(this.baseServiceFee);
			return df;
		},
		arcashPay: function () {
			let df =
				Number(this.cartPrice.total_product_amount) +
				Number(this.deliveryFee) +
				Number(this.baseServiceFee);
			return df;
		},
		//现金待支付金额
		abcashPay: function () {
			let df =
				Number(this.cartPrice.total_product_amount) +
				Number(this.deliveryFee) +
				Number(this.baseServiceFee);
			var balance = Number(this.arFee < 0 ? 0 : this.arFee);
			df = df - balance < 0 ? 0 : df - balance;
			return df;
		},
		//待支付费用
		payFee: function () {
			var arFee = Number(this.arFee);
			var abFee = Number(this.abFee);
			let df = this.cashPay - abFee - arFee - this.couponMoney;
			if (df < 0) {
				//this.arValue = this.cashPay;
				df = this.cashPay - abFee - arFee - this.couponMoney;
			}
			return Math.abs(Number(df)).toFixed(2);
		},
		lrp_text: function () {
			if (!this.newcustomer || this.LRPNum == null || !this.showFreeFreight) return null;

			if (this.LRPNum < 6) {
				return ` 还差${6 - Number(this.LRPNum)}个月满足免运费资格`;
			} else {
				return " 您已经满足免运费资格";
			}
		},
		menuList() {
			let productListArr = new Array();
			let newArr = this.shopCart || [];
			let op = this.isPVOriginalPrice;
			newArr.forEach((item, index) => {
				let product = this.productList[item.sku];
				if (!product) return;

				//处理购物车数据 limit num
				let productPrice = product.specproducts[0] || {};
				var Price = op
					? productPrice.original_price
					: productPrice.price;
				product.price = Price;
				product.point = item.point;
				product.pt = item.pt;
				product.num = item.num;
				product.additionals = item.additionals;

				productListArr.push(product);
			});
			if (newArr[0]) {
				this.loadpromoteList();
			}
			console.log(productListArr)
			return productListArr;
		},
		isbirthday() {
			var birthdaydata = this.selShopCart.filter(
				(u) => u.product_flag == 10
			);
			if (birthdaydata[0]) {
				return true;
			}
			return false;
		},
		hideNewCustomerCell(){
			return this.userInfo.value.binding.first_order_status == 0
		},
	},
	methods: {
		...mapActions([
			"initWarehouseAction",
			"getCustomerNumStatisticsAction",
			"initProductStock",
			"selectWarehouseAction",
			"postAddAddressAction",
			"getWechatUserInfoAction",
			"delAddressAction",
			"getTipDetailAction",
			"saveCartAction",
			"saveStoreIdAction",
			"CheckPoint",
			"CheckAR",
			"CheckCart",
			"initPromoteAction",
			"updateCartAction",
			"getAccountBalanceAction",
			"checkAccountBalanceAction",
			'lrptSaveCustomerDateAction',
			'getCustomerCouponsAction',
			'getBOGOConfigAction',
			'getArticleDetailAction',
			'getPurchaseEventAction',
			'setPurchaseModalAction',
		]),
		...mapMutations([
			"SET_ORDERTYPE",
			"SET_CART_TOTAL",
			"CLEAR_CART",
			'SET_COMBINEPROMOTEPRODUCT',
			"CHOOSE_ADDRESS",
			"SET_ORDERNN",
			"EDIT_CART1",
			"REDUCE_NEWPROMOCODE",
			"SET_SELECTMERGE",
			"SET_CARTCHECK",
			"LOAD_CARTCHECK",
			"SET_CARTCHECKALL",
			'TRIGGER_MERGE',
			'SET_PROMTE',
		]),
		openCoupon(){
			this.$refs.couponsView.show();
		},
		checkCombinePromote() {
			let combinePromote = this.promoteList.find(item=>item.promote_mode == 'combine')
			if (combinePromote) {
				let total = combinePromote.optionals.reduce((prev,cur)=>prev + cur.num,0)
				if (combinePromote.num && (total != combinePromote.num || this.default_store_id != this.$refs.combineModal.getStoreId())) {
					this.$refs.combineModal.show(combinePromote,this.default_store_id)
					return false
				}
			}
			return true
		},
		checkMutexPromote(){
			let mutexPromote = this.promoteList.find(item=>item.promote_mode == 'mutex')
			if (mutexPromote) {
				this.reSelectPromote(mutexPromote)
			}
		},
		async triggerMerge(v){
			if (this.isMerge && v == undefined) {
				var res = await this.getTipDetailAction("Tips_Product_Merge_PC");
				this.$CModal.show({
		          title:'提示(Tip)',
		          content:res.Content,
		          okText:'<p>取消合并，已知悉运费规则</p><p>Cancel consolidation, have learned freight rules</p>',
		          cancelText:'<p>不取消合并</p><p>Continue to consolidation</p>',
		          cancelStyle:'background-color:#D9D9D9;color:#333',
		          onOk:()=>{
		          	this.TRIGGER_MERGE(false)
		            this.$CModal.hide()
		          },
		          onCancel:()=>{
		            this.$CModal.hide()
		            this.mergeVisiable = false
		            this.$nextTick(()=>{
		            	this.mergeVisiable = true
		            })
		          }
		        })
			} else {
				this.TRIGGER_MERGE(v)	
			}
		},
		async saveCustomerDate() {
			if (!this.lrp_flag || !this.showLrpSet) return true
			var params = {
				step: "0",
				configid: null,
				vipno: null,
				customerid: this.getUserId,
				iscurrentmonth: 1,
				lrpdate: this.lrp_reminder,
				status: 1,
				lrp_flag: 1,
                sms_reminding: this.isLRP ? 1 : 0,
                UserToken:this.getAccessToken,
			};
			let ret = await this.lrptSaveCustomerDateAction(params);
			if (typeof ret === "number") {
				return true;
			} else {
				this.$Modal.warning({
					title: "小dō温馨提示(Tips)",
					content: ret,
				});
			}
			return false;
		},
		optVirtualflag: function () {
			var df =this.baseDeliveryFee;
			var item = this.selfPromoCode;
			if (item) {
				df = item.freight;
			}
			if ((df < this.baseDeliveryFee) || this.finalFree > 0) {
				return 2;
			}
			return 1;
		},
		isExchange: function (products) {
			return (
				!this.noStockText(products) &&
				products.specproducts[0].pt > 0 &&
				this.isOriginalPrice == false &&
				this.PromoPT &&
				this.poinBalance > 0
			);
		},
		async getAccountBalance() {
			let res = await this.getAccountBalanceAction();
			if (res && res[0]) {
				this.userBalance = res;
			}
			return [];
		},
		getAbBalance() {
			if (this.userBalance && this.userBalance[0]) {
				var res = this.userBalance.filter((u) => u.type == "AB");
				if (res[0]) {
					this.abshow = res[0].pass;
					return res[0].val;
				}
			}
			return 0;
		},
		getArBalance() {
			// let arResult = await api_methods.GetUserAccountAR(
			// 	this.getAccessToken,
			// 	"",
			// 	this.getVipNo,
			// 	0
			// );
			// if (
			// 	arResult &&
			// 	arResult.response &&
			// 	arResult.response.code == "1"
			// ) {
			// 	return arResult.data.value.ar;
			// 	//return -255;
			// }
			if (this.userBalance && this.userBalance[0]) {
				var res = this.userBalance.filter((u) => u.type == "AR");
				if (res[0]) {
					return res[0].val;
				}
			}
			return 0;
		},
		getPointBalance() {
			// var point = 0;
			// var expiryPoint = 0;
			// let pointResult = await api_methods.getUserAccountPoint(
			// 	this.getAccessToken,
			// 	"",
			// 	this.getVipNo,
			// 	0
			// );
			// if (
			// 	pointResult &&
			// 	pointResult.response &&
			// 	pointResult.response.code == "1"
			// ) {
			// 	point = pointResult.data.value.point;
			// 	expiryPoint = pointResult.data.value.expiryPoint;
			// 	//return 44;
			// }

			if (this.userBalance && this.userBalance[0]) {
				var res = this.userBalance.filter((u) => u.type == "PT");
				if (res[0]) {
					return {
						point: res[0].val,
						expiryPoint: res[0].expiryPoint,
					};
				}
			}
			return { point: 0, expiryPoint: 0 };
		},
		async initLRPNum() {
			if (!this.bogo_switch_tip && this.newcustomer) {
				var res = await this.getCustomerNumStatisticsAction(
					this.getVipNo
				);
				if (res && res[0]) {
					this.LRPNum = res[0].Nums1 || 0;
				} else {
					this.LRPNum = 0;
				}
			}
		},
		async defaultStore() {
			var item = this.warehouseList.filter((u) => u.Code == "501")[0];
			await this.selectStore(item);
		},
		async selectStore(item) {
			if (item.Code != "501" && this.selfPromoCode) {
				this.$Modal.warning({
					title: "小dō温馨提示(Tips)",
					content: "使用了优惠代码,只能选中送货上门哦!",
					onOk: () => {},
				});
			} else if (item.Code != this.default_store_id) {
				this.warehouseOpen = false;
				this.showLoading = true;
				// this.default_store_id = item.Code;
				// this.default_store=item;
				await this.initProductStock(item.Code);

				var ddm = "0";
				var ddmd = "门店自提";
				if (item.Code == "501") {
					//送货上门
					ddm = "1";
					ddmd = "送货上门";
				}
				this.selectWarehouseAction({
					default_delivery_mode: ddm,
					default_delivery_mode_desc: ddmd,
					default_store_id: item.Code,
					default_store_name: item.Name,
					default_store_nameen: item.NameEn,
				});
				this.handleProductStock();
				this.showLoading = false;
			} else {
				this.warehouseOpen = false;
			}
		},
		timeComparison(str, str1) {
			var valid_from = !str ? null : util.formatDate.dateFromStr(str);
			var valid_to = !str1 ? null : util.formatDate.dateFromStr(str1);
			var now = this.nowDate;
			return (
				(valid_from <= now || !valid_from) &&
				(valid_to >= now || !valid_to)
			);
		},
		async getMergeData() {
			var res = await this.getTipDetailAction("Tips_Product_Merge");
			if (res) {
				var ValidFrom = (res.ValidFrom || "").replace("T", " ");
				var ValidTo = (res.ValidTo || "").replace("T", " ");
				if (this.timeComparison(ValidFrom, ValidTo)) {
					this.doubtKey["Tips_Product_Merge"] = res.ontent;
					this.mergeData = {
						title:res.Title,
						subTitle:res.SubTitle,
						extStr1: res.ExtStr2,
						result: true,
					};
				} else {
					this.triggerMerge(true)
				}
			}
		},
		initAddress() {
			var initAddress = this.userInfo.value.binding.address || [];

			if (!this.choosedAddress) {
				var zc = initAddress.filter((u) => u.is_default == "1");
				if (zc[0]) {
					this.CHOOSE_ADDRESS({
						address: zc[0],
						index: 0,
					});
				} else {
					this.CHOOSE_ADDRESS({
						address: null,
						index: 0,
					});
				}
			} else {
				//避免缓存数据
				var zc = initAddress.filter(
					(u) => u.id == this.choosedAddress.id
				);
				if (zc[0]) {
					this.CHOOSE_ADDRESS({
						address: zc[0],
						index: 0,
					});
				} else {
					this.CHOOSE_ADDRESS({
						address: null,
						index: 0,
					});
				}
			}
		},
		setCartTotal(delivery_fee, service_fee, ar_value, ab_value, pvResult) {
			var result = this.isPVOriginalPrice;
			if (pvResult) {
				result = true;
			}
			this.SET_CART_TOTAL({
				delivery_fee,
				service_fee,
				ar_value,
				ab_value,
				result,
				check: true,
			});
		},
		setOtherCar() {
			var result = parseFloat(this.arFee);
			if (isNaN(result) || result <= 0) {
				result = 0;
			}
			var result1 = parseFloat(this.abFee);
			if (isNaN(result1) || result1 <= 0) {
				result1 = 0;
			}
			this.setCartTotal(
				this.deliveryFee,
				this.baseServiceFee,
				result,
				result1
			);
		},
		handleProductStock: function () {
			let newArr = this.shopCart;
			newArr.forEach((item) => {
				let product = this.productList[item.sku];
				if (product) {
					let sku = product.sku;
					let is_inventory = product.is_inventory;
					if (
						is_inventory == 1 ||
						(is_inventory == 10 && this.default_store_id == "501")
					) {
						product.control = -1; //未查询到库存信息
						product.stock = 0;
						let stockArry = this.productStock.filter(
							(u) => u.warehouse == this.default_store_id
						);
						if (stockArry[0]) {
							stockArry[0].stock.forEach((stock, index2) => {
								let control = stock.control;
								if (stock.sku === sku) {
									if (stock.stock <= 0) {
										product.control = control;
									} else {
										product.control = 2; //有库存，可以销售
									}
									product.stock = stock.stock;
								}
							});
						}
					} else if (is_inventory == 10) {
						product.control = -1;
					} else {
						product.control = 10; //不判断库存，任意销售
						product.stock = 999999999;
					}
				}
			});
		},
		async cleanCart() {
			this.$Modal.confirm({
				title: "提示(Tip):",
				content:
					"确定要清除购物车吗?<br>You sure you want to clear the cart?",
				loading: true,
				okText: "确定(Confirm)",
				cancelText: "取消(Cancel)",
				onOk: async () => {
					if (this.getVipNo) {
						let res = await api_methods.clearCart(
							this.getAccessToken,
							this.getUserId,
							this.userInfo.value.binding.user_id
						);
						this.SET_COMBINEPROMOTEPRODUCT()
						if (res && res.response && res.response.code == "1") {
							this.CLEAR_CART();
							this.$router.push({
								path: "/order/product",
							});
							this.$Modal.remove();
						} else {
							this.$Modal.error({
								title: "错误 (error)",
								content: res,
							});
						}
					} else {
						this.CLEAR_CART();
						this.$Modal.remove();
					}
				},
			});
		},
		reSetPromote(promoteCode){
			let promote = this.promoteList.filter(item=>item.promote_code == promoteCode)[0]
			this.$refs.combineModal.show(promote,this.default_store_id)
		},
		modifyPromote(product,factor){
			let num = product.num
			if (factor == 1) {
				let products = this.promoteList.filter(item=>item.promote_code == product.promote_code && item.sku != product.sku && item.num != 0)
				let stock = this.promote.value.filter(item=>item.code == product.promote_code)[0].store_id.filter(u => u.sku == product.sku)[0]
				if (!products.length) {
					this.showTips('赠品已经是最大赠送数量',3000)
					return
				}
				if (stock.stock < num + factor) {
					this.showTips(`${product.name}库存不足`,3000)
					return
				}
				product.num = num + factor
				products[0].num -= factor
				
			} else {
				if (num == 0) return
				let products = this.promoteList.filter(item=>item.promote_code == product.promote_code && item.sku != product.sku)
				let stock = this.promote.value.filter(item=>item.code == product.promote_code)[0].store_id.filter(u => u.sku == products[0].sku)[0]
				if (stock.stock < products[0].num - factor) {
					this.showTips(`${products[0].name}库存不足`,3000)
					return
				}
				product.num = num + factor
				products[0].num -= factor
			}
			
		},
		reSelectPromote(products){
			this.optionalPromotes = products.optionals
			this.optionalProduct = products
			this.mutexPromoteTip = products.detail_description.split(/<p[^>]*?>[\s\r\n\t]{0,}{products}[\s\r\n\t]{0,}<\/p>/)
			this.showReSelect = true
		},
		confirmOptionalPromote(){
			let promote_code = this.optionalProduct.promote_code,sku = this.optionalProduct.sku
			this.promote.value.filter(item=>item.code == promote_code).map(item=>{
				let detail = item.detail[0]
				let optionals = [...detail.optionals]
				let newDetail =Object.assign({},this.optionalProduct)
				detail.optionals = null
				newDetail.optionals = optionals
				item.detail = [newDetail]
				return item
			});
			this.SET_PROMTE(this.promote)
			this.loadpromoteList();
		},
		async initData() {
			this.getBOGOConfigAction().then(res=>{
				if (!res) return
				let date = new Date()
				let config = res.find(item=>item.validfrom <= date.valueOf() && date.valueOf() < item.validto)
				if (config) this.bogoConfig = config
			})
			if (!this.shopCart[0]) {
				if (this.orderType != 0) {
					this.$router.push("/order/product");
				} else {
					this.$router.push("/order/product");
				}
				return false;
			}

			if (this.newcustomer) {
				this.SET_ORDERTYPE(11);
			} else {
				this.SET_ORDERTYPE(0);
			}
			await this.initWarehouseAction();

			this.productList = this.Produckey();

			await this.initProductStock(this.default_store_id);
			if (this.getVipNo) {
				if ((await this.initPromoteAction()) != 1) {
					this.$Modal.error({
						title: "错误 (error)",
						content: "促销获取异常",
						okText: "确定",
						onOk: () => {
							this.$router.push("/order/product");
						},
					});
					return;
				}

				this.initLRPNum();

				this.addresses =
					this.userInfo.value &&
					(this.userInfo.value.binding.address || []);

				if (!this.isOriginalPrice) {
					await this.getAccountBalance();
					this.balance = this.getAbBalance();
					this.arBalance = this.getArBalance();
					var pointModel = this.getPointBalance();

					this.poinBalance = pointModel.point;
					this.expiryPoint = pointModel.expiryPoint;
				}
				this.initAddress();
			}

			this.LOAD_CARTCHECK();

			this.checkAutoAll();

			if (this.balance > 0) {
				this.abValue = this.balance;
			}
			var balanceRecord = this.balanceRecord || {};
			if (balanceRecord.ar_value > 0) {
				this.arValue = balanceRecord.ar_value;
			}

			this.setOtherCar();
			// Mark：这么写是正确的，需要在setOtherCar执行后再判断是否有点数兑换
			// 与1306行合并改动较大（因为computed arFee() 中给arValue赋值），改动可能会导致奇怪的错误
			if (this.cartPrice.total_change_point) {
				this.arValue = 0
			}
			await this.getMergeData();

			this.coupons = await this.getCustomerCouponsAction(this.userInfo.value.binding.register.vip_no);
			if (this.default_store_id != "501" && this.selfPromoCode) {
				this.$Modal.warning({
					title: "小dō温馨提示(Tips)",
					content: "使用了优惠代码,只能选中送货上门哦!",
					onOk: async () => {
						await this.defaultStore();
					},
				});
			} else {
				this.handleProductStock();
				this.showLoading = false;
			}
			this.removeInvalidProducts()
			this.autoCheckCoupons()
			let skus = this.cartInfo.value.detail.map(item=>item.sku)
			this.getPurchaseEventAction(skus.join(',')).then(res=>{
				if (res) {
					for (let sku of res.sortedSku) {
						if (!this.purchaseModal[sku] && skus.indexOf(sku) != -1) {
							this.purchaseModalContent = res[sku].extension.tips
							this.mainSku = sku
							this.showPurchaseModal = true
							this.setPurchaseModalAction({sku,num:1})
							break
						}
					}
					
					
				}
			})
		},
		// 移除限购的产品
		removeInvalidProducts(){
			this.cartInfo.value.detail.forEach(item=>{
				if (this.hiddenSKUs[item.sku]) {
					this.deleteProduct(item)
				}
			})
		},
		handleCancel(){
			this.show = false
			if (this.pickResolve) {
				this.pickResolve(null,false)
				this.pickResolve = null
			}
		},
		handleConfirm (address) {
			if(!address.is_default && !this.hasDefaultAddress) {
				return this.$Modal.confirm({
					title: '默认地址',
					content: '是否要将该地址设置为默认地址',
					okText: '是',
					cancelText: '否',
					onOk: () => {
						address.is_default = 1
						this.asyncOK(address)
					},
					onCancel: () => {
						this.asyncOK(address)
					}
				})
			}
			this.asyncOK(address)
		},
		Produckey() {
			let listKey = {};
			this.productInfo.value.forEach((item) => {
				item.products.forEach((produc) => {
					if (!listKey[produc.sku]) {
						listKey[produc.sku] = produc;
					}
				});
			});
			return listKey;
		},
		async oepnFreightDoubt(code){
			var content = null;
			if (!this.freightTip.Content) {
				this.freightTip = await this.getTipDetailAction(code);
			}
			content = this.isBogoInCart && this.freightTip.ExtStr2 ? this.freightTip.ExtStr2:this.freightTip.Content
			this.$Modal.info({
				title: "提示(Tip):",
				content: content,
			});
		},
		async oepnDoubt(code) {
			var content = null;
			if (this.doubtKey[code]) {
				content = this.doubtKey[code];
			} else {
				var res = await this.getTipDetailAction(code);
				if (res) {
					content = res.Content;
					this.doubtKey[code] = content;
				}
			}

			this.$Modal.info({
				title: "提示(Tip):",
				content: content,
			});
		},
		gowhatLRP(){
			window.open(`${cvoUrl}/vo/index.html#/show/lrp`)
		},
		deliveryOnly(list) {
			var result = false;
			list.forEach((item, index) => {
				if (!result && item.product_flag != 1) {
					var obj = this.menuList.filter((u) => u.sku == item.sku);
					if (obj[0]) {
						if (obj[0].is_inventory == "10") {
							result = true;
						}
					}
				}
			});
			return result;
		},
		ListingOnly(list) {
			var result = false;
			list.forEach((item, index) => {
				if (!result && item.product_flag != 1) {
					var obj = this.menuList.filter((u) => u.sku == item.sku);
					if (obj[0]) {
						if (
							obj[0].online_myo_begin &&
							obj[0].online_myo_begin != "" &&
							this.nowDate <
								util.formatDate.dateFromStr(
									obj[0].online_myo_begin
								)
						) {
							if(!this.onlineFlash(item.sku))
							 result = true;
						}
					}
				}
			});
			return result;
		},
		checkLRPTPV(list) {
			var name = "";
			var pv = 0;
			list.forEach((item) => {
				if (item.product_flag != 20) {
					var ppt = item.pt > 0 ? item.point / item.pt : 0;
					pv += (item.num - ppt) * item.pv;
				} else {
					name += item.name + ",";
				}
			});
			if (pv >= 125) {
				return null;
			}
			return name.substring(0, name.length - 1);
		},
		checkLRPTPV(list) {
			var name = "";
			var pv = 0;
			list.forEach((item) => {
				if (item.product_flag != 20) {
					var ppt = item.pt > 0 ? item.point / item.pt : 0;
					pv += (item.num - ppt) * item.pv;
				} else {
					name += item.name + ",";
				}
			});
			if (pv >= 125) {
				return null;
			}
			return name.substring(0, name.length - 1);
		},
		checkCostLimt(list){
			var result = false
			list.forEach((item) => {
			if (!result) {
				var product = this.SkuLimt.filter(u=>u.limit_sku==item.sku&&u.limit_type=='AddCost')[0]
					if (product) {
						var check = list.filter(u => u.sku == product.sku && item.num == u.num)[0]
						if (!check) {
							result = true
						}
					}
				}
			})
			return result
		},
		checkPTList(list){
			var name="";
			list.forEach((item)=>{
				var newItem=this.SkuLimt.filter(u=>u.sku==item.sku&&u.limit_type=='PT')[0]
				if(newItem){
					var ppt = item.pt > 0 ? item.point / item.pt : 0;
					if(ppt<item.num){
						name+=item.name+',';
					}
				}
				
			})
			return name.substring(0,name.length-1);
		},
		Ispromote(ll) {
			//检测此单是否存在促销
			if (this.promote_code) {
				return 1;
			}
			var is = ll.filter((u) => u.product_flag == 1);
			if (is[0]) {
				return 1;
			}

			return 0;
		},
		async getLevelGift(){
			let list = []
			let levelGiftPromotions = this.promote?.value?.filter(item=>item.other_rules?.toLowerCase() == 'levelgift')
			if (levelGiftPromotions?.length) {
				let levelGiftPromotion = levelGiftPromotions[0]
				// 判断库存
				let isStocked = true
				for(var i = 0; i < levelGiftPromotion.detail.length; i++){
					let product = levelGiftPromotion.detail[i]
					let stock = levelGiftPromotion.store_id.filter(u => u.sku.toLowerCase() == product.sku.toLowerCase() &&u.store_id == this.default_store_id)
					if (!stock.length || stock[0].stock < product.max_num) {
						isStocked = false
						break
					} else {
						product.control = 2
						product.num = product.max_num
						this.pushProduct(list,product)
					}
				}
				if (isStocked) {
					let result = await this.asyncModal({
						title:'温馨提示',
						content:levelGiftPromotion.description,
						okText:"是(Yes)",
						cancelText:'否(No)'
					})
					if (result) {
						return list
					}
				}
			}
			return []
		},
		allCartList() {
			let newArr = new Array();
			const pushProduct = (item,product_flag)=> {
				if (item.is_hot == "1" && this.orderType != 0) {
					product_flag = 100;
				}

				var remark=null
				if(item.promo_code!=''&&item.promo_code){
					remark=this.getBySkuJson(item.sku)
				}
				let spec_code = null,spec_name = null,Url = null,specification=item.specification
				if (product_flag == 3) {
			        var obj = this.additionalProducts.filter(u => u.sku == item.sku)
			        if (obj[0]) {
			          	Url = obj[0].image_path_big
			          	let mainSku = this.additionalsMainMap[item.sku]
				        spec_name = this.purchaseEvent[mainSku].title
				        spec_code = this.purchaseEvent[mainSku].code
				        specification = obj[0].specification;
			        }
			        
			    }

				newArr.push({
					attrs: [],
					extra: {},
					id: item.id,
					category_id: item.category_id,
					name: item.name,
					packing_fee: item.packing_fee,
					price: item.price,
					pt: item.pt,
					pv: item.pv,
					point: item.point,
					amount: item.amount, //现金支付金额
					ar_value: 0, //AR支付金额
					num: item.num, //数量(个数)，point支付和 amount支付总计个数
					sku_id: item.sku_id,
					sku: item.sku,
					specs: item.specs,
					stock: item.stock,
					selected: item.selected,
					spec_code,
					spec_name,
					product_flag: product_flag,
					promo_code: item.promo_code,
					Url,
					specification,
					remark
				});
			}
			this.shopCart.forEach((item) => {
				if (item.num > 0) {
					var product_flag = item.is_lrpt_product || 0;
					pushProduct(item,product_flag)
					if(item.additionals?.length) {
						item.additionals.forEach(item1=>pushProduct(item1,3))
					}
				}
			});
			return newArr;
		},
		shopCartList() {
			let newArr = new Array();
			const pushProduct = (item,product_flag) => {
				if (item.is_hot == "1" && this.orderType != 0) {
						product_flag = 100;
				}
				newArr.push({
					attrs: [],
					extra: {},
					id: item.id,
					category_id: item.category_id,
					name: item.name,
					packing_fee: item.packing_fee,
					price: item.price,
					pt: item.pt,
					pv: item.pv,
					point: item.point,
					amount: item.amount, //现金支付金额
					ar_value: 0, //AR支付金额
					num: item.num, //数量(个数)，point支付和 amount支付总计个数
					sku_id: item.sku_id,
					sku: item.sku,
					specs: item.specs,
					stock: item.stock,
					selected: item.selected,
					spec_code: null,
					spec_name: null,
					product_flag: product_flag,
					promo_code: item.promo_code,
					Url: null,
				});
			}

			this.selShopCart.forEach((item) => {
				if (item.num > 0) {
					var product_flag = item.is_lrpt_product || 0;
					pushProduct(item,product_flag)
					if(item.additionals?.length) {
						item.additionals.forEach(item1=>pushProduct(item1,3))
					}
				}
			});
			return newArr;
		},

		setCarImg(list) {
			list.forEach((item, index) => {
				if (item.product_flag != 1) {
					var obj = this.menuList.filter((u) => u.sku == item.sku);
					if (obj[0]) {
						item.Url = obj[0].image_path_big;
						item.specification = obj[0].specification;
					}
				}
			});
			return list;
		},
		// 验证自提促销
		checkPickPromotion(){
			return new Promise(async(resolve, reject) =>{
				if (this.default_store_id == '501') {
					resolve(true)
					return
				}

				// 是否在抽奖期间并满足抽奖资格
				
				let luckyDraw = await this.getTipDetailAction("PayMent_Lucky_Draw");
				let canDraw = this.timeComparison(luckyDraw.ValidFrom,luckyDraw.ValidTo) && this.payPv >= luckyDraw.Keywords
				// 判断是否有无门店库存的促销
				let noStockLength = this.promoteList.filter(item=>item.control == 1 && item.num == 0)?.length
				if (!noStockLength && !canDraw) {
					resolve(true)
					return
				}

				// 判断是否有注册地址
				if(this.addresses?.length) {
					let addr = this.addresses.filter(item=>item.address_type == 0)[0]
					if (!addr) addr = this.addresses[0]
					let {province,city,county,town,street} = addr
					this.asyncModal({
						title:'提示',
						content:`<p>赠品将在下单后单独安排快递寄送至以下地址：</p><p>${province} ${city} ${county} ${town} ${street}</p>`,
						okText:"确认(Confirm)",
						cancelText:'去修改(To modify)',
						onOk:async()=>{
							resolve(true)
							this.chooseAddress(addr)
						},
						onCancel:()=>{
							this.pickResolve = (address,res)=>{
								this.chooseAddress(address)
								resolve(res)
							} 
							this.modifyAddress(addr)
						}
					})
				} else {
					this.asyncModal({
						title:'提示',
						content:'赠品将在下单后单独安排快递寄送，请添加快递收件地址。',
						okText:"新增地址(Add Address)",
						cancelText:'取消(Cancel)',
						onOk:async()=>{
							this.pickResolve =(address,res)=>{
								resolve(res)
							} 
							this.editAddress.address_type = 0
							this.show = true
						},
						onCancel:()=>{
							resolve(false)
						}
					})
				}
			})
		},
		// 验证赠送PT促销
		checkPTPromotion(){
			return new Promise(async(resolve, reject) =>{
				let ptPromotion = this.promoteList?.filter(item=>item.gift_type == 'PT')[0]
				if(ptPromotion){
					await this.sleep(300)
					let description = this.promote.value.filter(item=>item.code == ptPromotion.promote_code)[0].detail_description
					this.$Modal.info({
						title:'提示',
						content:description,
						onOk: async() => {
							resolve(true);
						},
					});
					return
				}
				resolve(true) 
			})
		},
		async saveThisCart(type, pvResult,birthdayText) {
			let set_result = await this.saveCustomerDate()
			if (!set_result) return
			var birthdayCode = null;
			var birthdaydata = this.selShopCart.filter(
				(u) => u.product_flag == 10
			);
			if (birthdaydata[0]) {
				birthdayCode = "birthday";
			}

			var is_confirm = type;
			var result = parseFloat(this.arFee);
			if (isNaN(result) || result <= 0) {
				result = 0;
			}
			var result1 = parseFloat(this.abFee);
			if (isNaN(result1) || result1 <= 0) {
				result1 = 0;
			}

			this.setCartTotal(
				this.deliveryFee,
				this.baseServiceFee,
				result,
				result1,
				pvResult
			);
			let ll = this.allCartList();
			let cx = this.CxList().filter(item=>item.num);
			let gift = []
			if (type == 1) {
				gift = await this.getLevelGift()
			}
			ll = [...ll, ...cx,...gift];
			let cv = this.cartInfo.value;

			if (type == 1) {
				let checkRes = await this.checkPickPromotion()
				if(!checkRes) return
				type = this.Ispromote(ll);
			}

			// 验证PT促销
			await this.checkPTPromotion()
			ll = this.setCarImg(ll);
			var for_vipno = this.userInfo.value.binding.register.vip_no;
			var catalog = this.userInfo.value.binding.catalog;
			var first_order_status = this.userInfo.value.binding
				.first_order_status;
			if (this.forCustomer) {
				for_vipno = this.forCustomer.vipno;
				catalog = this.forCustomer.catalog;
				first_order_status = this.forCustomer.first_order_status;
			}
			if (this.selfPromoCode) {
				if (this.selfPromoCode.lrp_flag == 0) {
					catalog = "Standard";
				}
				if (this.selfPromoCode.lrp_flag == 2) {
					catalog = "LRP";
				}
			}
			// } else if (birthdayCode) {
			// 	catalog = "Standard";
			// }
			//var promote = this.selffirstOpentoAll;
			let minCart = {
				id: cv.id,
				is_result: type,
				is_confirm: is_confirm,
				promo_code: null,

				catalog: catalog,
				vip_no: for_vipno,
				first_order_status: first_order_status,

				customer_id: this.userInfo.value.binding.user_id,
				store_id: this.default_store_id,
				address_id: this.choosedAddress?.id,
				total_num: cv.num,
				total_price: cv.total_price,
				total_pv: cv.total_pv,
				total_change_point: cv.total_change_point,
				total_change_point_num: cv.total_change_point_num,
				total_product_amount: cv.total_product_amount,
				delivery_fee: cv.delivery_fee,
				service_fee: cv.service_fee,
				ar_value: cv.ar_value,
				ab_value: cv.ab_value,
				pay_fee: cv.pay_fee - this.couponMoney,
				discount:this.couponMoney,
				cc:this.usedCouponCodes.join(','),
				spec_code: cv.delivery_fee > 0 ?null:this.promote_code||birthdayCode,
				lrpt_order: 0,
				remark: birthdayCode == "birthday" ? (birthdayText || this.BHtext ): null,
				deBHtext:encodeURI(this.BHtext),
				detail: ll,
			};
			let ret = await this.saveCartAction({ minCart, type: is_confirm });
			return ret;
		},
		async confirmLoad(type) {
			let birthdayText = null
			if (type == 0) {
				this.settlementLoad = true;
			} else if (type == 2) {
				if (this.BHtext) {
					this.BHtext = this.BHtext.replace(/[\s\S]/g,ch=>{
						let ascii = ch.charCodeAt()
						if (ascii == 10) return ''
						if (ascii == 13) return ''
						if (ascii == 8203) return ''
						if (ascii == 160 || ascii == 12288) return ' '

						return ch
					})
					if (!/^[A-Za-z\s]{0,20}$/.test(this.BHtext)) {
						//this.BHerror_text=true;
						this.BHerror_input = true;
						return false;
					}
					birthdayText = this.BHtext
				} else {
					this.BHerror_input = true;
					return false;
				}
				this.settlementLoad = true;
			} else if (type == 3) { //生日套装不刻字
				birthdayText = '-1'
				type = 2
			} else {
				if (!this.getVipNo) {
					this.$router.push({
						path: "/order/product",
					});
					return;
				}
				this.continueLoad = true;
			}
			this.BHshow = false;

			var res = await this.confirm(type,birthdayText);
			if (res) {
				if (typeof res == "string") {
					this.$Modal.error({
						title: "错误 (error)",
						content: res,
					});
				} else {
					this.$Modal.info({
						title:res.title,
						content: res.content,
						onOk:()=>{
							res.onOk && res.onOk()
						},
						okText:res.okText || '确认',
					});
				}
				
			}
			this.continueLoad = false;
			this.settlementLoad = false;
		},

		confirm1() {
			return new Promise((resolve, reject) => {
				this.$Modal.info({
					title: "升级提示",
					content:
						`您的本次订购已经达到${pc_pv_threshold}PV，请完善您的个人资料成为优惠顾客，并且可以立即以优惠顾客价格支付本次订单。<br>Your order has reached ${pc_pv_threshold}PV,please fill in your personal information to become preferred customer, and you can pay for this order at preferred customer price immediately.`,
					okText: "是(Yes)",
					onOk: () => {
						location = `${cvoUrl}/vo/index.html#/enroll/appendPcInfo?token=${this.getAccessToken}&source=WebSite`;
					},
				});
			});
		},
		mergeConfirm() {
			return new Promise((resolve, reject) => {
				this.$Modal.confirm({
					title: "提示",
					content: this.mergeData.extStr1,
					okText: "确定(Confirm)",
					cancelText: "取消(Cancel)",
					onOk: () => {
						resolve(true);
					},
					onCancel: async () => {
						resolve(false);
					},
				});
			});
		},
		asyncModal({
			title,
			content,
			okText="确定(Confirm)",
			cancelText='取消(Cancel)',
			onOk=(async()=>{}),
			onCancel=(async()=>{}),
		}) {
			return new Promise((resolve, reject) => {
				this.$Modal.confirm({
					title,
					content,
					okText,
					cancelText,
					onOk: async() => {
						await onOk()
						resolve(true);
					},
					onCancel:async() => {
						await onCancel()
						resolve(false);
					},
				});
			});
		},
		async confirm(type,birthdayText) {
			let go = "/order/confirm";
			// 首单未购买首购套装，弹框提醒用户
			if (!this.userInfo.value.binding.first_order_status && !this.checkFirstSet().length) {
				let res = await this.asyncModal({
					title:'温馨提示(Tip)',
					content:'仅首单才可购买优惠首购套装，您尚未选购，是否要购买？Only the first order can purchase the enrolment kit, you haven’t choose, would you like to have this chance?',
					okText:'去看看首购套装(Go to purchase)',
					cancelText:'放弃机会(Give up)'
				})
				if (res) {
					this.$router.push('/order/product?type=first order')
					return
				} else {
					await this.sleep(300)
				}
			}
			// 判断combine促销，选择的数量是否正确
        	if(!this.checkCombinePromote()) return
			if (this.checkCoupons() && type != 1) {
				let response = await this.asyncModal({
					title:'提示',
					content: '您还有未使用的优惠券，请确认是否使用。You have unused coupon, please confirm for use.',
					okText:'使用(Use)',
					cancelText:'不使用(Not to use)'
				})
				if (response) {
					this.autoCheckCoupons()
				}
				await this.sleep(300)
			}else if (this.showCoupons && type != 1) {
				let coupon = this.validCoupons[0]
				let perNum = this.couponsDef[coupon.code].perNum
				let payFee = parseFloat(this.cartInfo?.value?.total_price) + parseFloat(this.deliveryFee); //加上积分兑换的金额以计算可使用券的金额
				if (payFee < perNum) {
					let response = await this.asyncModal({
						title:'提示',
						content: `消费每满${perNum}元，即可使用1张电子优惠卷`,
						okText:'继续加购(Go On Shop)',
						cancelText:'不使用(Not to use)'
					})
					if (response) {
						this.$router.push({
							path: '/order/product',
						})
						return
					}
					await this.sleep(300)
				}
				
			}
			if (type == 0 || type == 2) {
				if (this.getVipNo) {
					go = "/order/confirm";
				} else {
					if(this.isMobile){
						this.showCustomer=true;
						//this.showCustomer=false;
						return 
					}

					this.goLogin();
					return;
				}
			} else {
				go = "/order/product?preaction=1";
			}
			this.SET_SELECTMERGE(0);
			let ret = null;
			if (type == 0) {
				ret = await this.checkOrder();
				if (ret) {
					return ret;
				}
				if (this.mergeShow && this.isMerge) {
					if (await this.mergeConfirm()) {
						var mergeType = this.optVirtualflag();
						this.SET_SELECTMERGE(mergeType);
						await this.sleep(300)
					} else return;
				}
			}
			let pvResult = false;

			ret = await this.saveStoreIdAction(this.default_store);
			if (ret) {
				return ret;
			}
			ret = await this.saveThisCart(type == 1 ? 0 : 1, pvResult,birthdayText);
			if (ret && ret.response && ret.response.code == "1") {
				if (ret.data.value.code == 1) {
					this.SET_ORDERNN(null);
					if (type == 0) {
						if (
							this.isOriginalPrice &&
							(!this.selfCarNo ||
								(this.payPv < pc_pv_threshold && this.selfCarNo))
						) {
							this.newValue = true;
							return;
						}
					}
					this.$router.push({
						path: go,
					});
				} else if (ret.data.value.code == 1000) {
					this.$Modal.error({
						title: "错误 (error)",
						content: ret.data.value.message,
						onOk: () => {
							this.SET_ORDERNN(null);
							this.$router.push({
								query: go,
							});
						},
					});
				} else if (ret.response.errorCode == "0100") {
					this.$Modal.error({
						title: "错误 (error)",
						content: ret.data.value.message,
						loading: true,
						okText: "重新加载",
						onOk: async () => {
							await this.getWechatUserInfoAction();
							this.$Modal.remove();
						},
					});
				} else {
					return ret.data.value.message;
				}
			}
		},
		async confirmLoad1() {
			var data = this.selShopCart.filter((u) => u.product_flag == 10);
			if (data[0]) {
				this.settlementLoad = true;
				var ret = await this.checkOrder();
				this.settlementLoad = false;
				if (ret) {
					if (typeof ret == 'string') {
						this.$Modal.error({
							title: "错误 (error)",
							content: ret,
						});
					} else {
						this.$Modal.info({
							title:ret.title,
							content:ret.content,
							onOk:()=>{
								ret.onOk && ret.onOk()
							},
							okText:ret.okText || '确认',
						})
					}
					
					return false;
				}

				if(	this.nowDate <util.formatDate.dateFromStr(this.noBirthday) && this.nowDate >= util.formatDate.dateFromStr(this.birthdayStart)){
					this.BHshow = true;
				}
				else{
					this.BHtext='-1'
					await this.confirmLoad(0);
				}
				
			} else {
				await this.confirmLoad(0);
			}

			//this.$router.push("/order/payment");
		},
		isIncompleteAddress(address){
			let isIncomplete = false
			let keys=['province_id','city_id','county_id','moblie_phone','name','street']
			keys.forEach(key=>{
				if (!address[key]) {
					isIncomplete = true
				}
			})
			return isIncomplete
		},
		async checkOrder() {
			if (
				!(
					this.userInfo &&
					this.userInfo.value &&
					this.userInfo.value.binding &&
					this.userInfo.value.binding.user_id
				)
			) {
				return "请登录";
			} else if (!this.default_store_id) {
				return "请选择一个配送仓库";
			} else if (!this.qchoosedAddress.id) {
				if(this.default_store_id == '501'){
					if (!this.addresses?.length) {
						return {
							 title:'提示(Tip)',
							 content:'请添加一个收货地址<br> Please add your delivery address. ',
							 okText:'添加收货地址(Add address)',
							 onOk:()=>{
								 this.addAddress()
							 }
						 }
					}
					return "请选择址收货地址";
				}
			} else if(this.isIncompleteAddress(this.qchoosedAddress)) {
				return "请补全收货地址";
			}

			var first_order_status = !this.forCustomer
				? this.userInfo.value.binding.first_order_status
				: this.forCustomer.first_order_status;
			var forlevel = !this.forCustomer
				? this.userInfo.value.binding.customer_type.toLowerCase()
				: this.forCustomer.customer_type;
			if (first_order_status == 0) {
				let defaultPV =
					this.userInfo.value.binding.default_pc_first_order_min_pv ||
					pc_pv_threshold;
				if (this.payPv < defaultPV && forlevel != "rt") {
					return {
						title:'温馨提示(Tip)',
						content:`首购订单满足${pc_pv_threshold}点即可享受优惠顾客价（First order minimum ${pc_pv_threshold}PV could enjoy the preferential customer price）`
					};
				}
			}

			let ll = this.shopCartList();

			if (!ll || ll.length <= 0) {
				return "请选择产品";
			}

			if (this.default_store_id != "501") {
				if (this.deliveryOnly(ll)) {
					return "部分产品仅限快递";
				}
			}
			if (this.ListingOnly(ll)) {
				return "部分产品未上市";
			}

			var item = this.checkLRPTPV(ll);
			if (!this.isEmpty(item)) {
				return "您购买了" + item + "点数必须要满足125点哦。";
			}

			var costLimt = this.checkCostLimt(ll);
			if (costLimt) {
				return '加价购产品需要购买主产品，或比例不对哦！'					
			}
			var cv = this.cartInfo.value;
			if (true) {
				let arFee = parseFloat(this.arFee);
				arFee = isNaN(arFee) ? 0 : arFee;
				if (arFee > 0 && cv.total_change_point > 0) {
					return "亲爱的顾客，非常抱歉，产品积分和点数兑换不能同时使用哦！Dear member, SORRY. The redeemed points should be under twice than total order PVs.";
				}

				var resultcashPay = (((this.cashPay - this.couponMoney) / 3) * 2).toFixed(2);
				if (arFee > resultcashPay) {
					return "亲爱的顾客，非常抱歉，使用产品积分不能超过支付金额两倍！";
				}

				if (cv.total_change_point > cv.total_pv * 2) {
					return "亲爱的顾客，非常抱歉，兑换回馈点数不能超过订单总产品点数的两倍";
				}
			}

			var ptList=this.checkPTList(ll)
			if(!this.isEmpty(ptList)){
				 return {
				 	title:'温馨提示',
				 	content:'"'+ptList+'"需要全部使用回馈点数进行兑换购买哦！'
				 }
		             
			}
			// var result = await this.CheckPoint({
			// 	point: cv.total_change_point,
			// 	step: 1
			// });
			// if (result) {
			// 	return result;
			// }
			// result = await this.CheckAR({ ar: this.arFee, step: 1 });
			// if (result) {
			// 	return result;
			// }

			var msg = await this.checkAccountBalanceAction({
				ar: this.arFee,
				pt: cv.total_change_point,
				ab: this.abFee,
				step: 1,
			});
			if (msg) {
				return msg;
			}

			var store_id = this.default_store_id;
			var result = await this.CheckCart({ ll, store_id, step: 1 });
			if (result) {
				return result;
			}
			return null;
		},
		cdeleteAddress(address) {
			let vm = this;
			if (address.address_type == 0) {
				this.$Modal.error({
					title: "错误 (error)",
					content: "注册地址不可删除哦",
				});
				return;
			}
			this.deleteAddress(address).then((res) => {
				if (vm.qchoosedAddress.id == address.id) {
					vm.CHOOSE_ADDRESS({
						address: null,
						index: 0,
					});
				}
			});
		},
		chooseAddress: function (address) {
			this.CHOOSE_ADDRESS({ address, index: 0 });
		},
		noStock(product) {
			return (
				!(product.specproducts && product.specproducts.length > 0) ||
				!(product.control == 2 || product.control == 10)
			);
		},
		noStock1(product) {
			return !(product.control == 2 || product.control == 10) && !product.num && product.promote_mode != 'combine';
		},
		onlineFlash(sku){
			var model=this.getProductFlash(sku);
			if(model[0]&&model[0].max_num>0){
				if(this.timeComparison(model[0].buy_begintime,model[0].buy_endtime)){
					return true;
				}
			}
			return false;
		},
		noStockText(product) {
			if (product.is_inventory == 10 && this.default_store_id != "501") {
				return '仅快递<em class="no_mobile">(Only Delivery)</em>';
			} else if (
				product.online_myo_begin &&
				product.online_myo_begin != "" &&
				this.nowDate <
					util.formatDate.dateFromStr(product.online_myo_begin)
			) {
				if(!this.onlineFlash(product.sku)){
					return '敬请期待<em class="no_mobile">(Coming Soon)</em>';
				}
			} else if (this.noStock(product)) {
				if (product.product_flag == 1) {
					return '售罄<em class="no_mobile">(Sold Out)</em>';
				}
				return '暂时缺货<em class="no_mobile">(Out of Stock)</em>';
			}
			return null; //正常销售
		},

		BHscancel() {
			this.BHshow = false;
			this.confirmLoad(3)
		},
		showChoosePTList(products) {
			if (products) {
				this.choosedProducts = products;
			}
			this.showPTChange = !this.showPTChange;
		},
		resuldeliveryFee() {
			if(this.isMerge){
				return 0
			}
			var df = Number(this.systemDetail?.float_delivery_fee);
			return df - this.finalFree <= 0
				? df.toFixed(2)
				: this.deliveryFee.toFixed(2);
		},
		operating() {
			this.isAllAddress = !this.isAllAddress;
		},
		showTips(msg, s, is) {
			this.$Toast.show(msg, { duration: s });
		},
		expiryMore() {
			location = `${cvoUrl}/vo/index.html#/lrp?token=${this.getAccessToken}&source=WebSite`;
		},
		goto() {
			location = `${cvoUrl}/vo/index.html#/enroll/create?level=rt`;
		},
		deleteProduct(product) {
			let sku = product.sku;
			let num = 0;
			let edit_cart = this.EDIT_CART1;
			edit_cart({ sku, num });
			//检测大会代码是否删除 如果删除 将删除状态
			var newcode = this.newpromoCode[sku];
			if (newcode) {
				this.REDUCE_NEWPROMOCODE(sku);
			}
			this.IsPromoteTip(sku, 0);
			this.updateCart(sku, num);
		},
		updateCart(sku, num) {
			var params = {
				//customerId:this.getUserId,
				sku,
				num,
			};
			this.updateCartAction(params);
		},
		close() {
			this.newValue = false;
		},
		goDetail(product) {
			this.$router.push("/order/product/detail?sku=" + product.sku);
		},
		allCarSel(){
			var cartCheck=this.cartCheck||{}
			var result=this.allSel
			this.SET_CARTCHECKALL(result)
			
			this.setOtherCar();
		},
		checkAutoAll(){
			if(this.isAllSelCart){
				this.allSel=true;
			}
			else{
				this.allSel=false;
			}
		},
		carSel(sku) {
			this.SET_CARTCHECK(sku);
			this.checkAutoAll();
			this.setOtherCar();
		},
		isCartCheck(sku) {
			// let checkList=this.cartCheck||[]
			// var item= checkList.filter(u=>u.sku==sku)
			// if(item[0]) return true
			// return false;
		},
		showPromoCode(products,type) {
			if (products) {
				this.PromoModel = products;
				this.PromoModelType=type
			}
			this.PromoModelShow = !this.PromoModelShow;
		},
		showArTip(){
			this.showTips('亲爱的顾客，非常抱歉，产品积分和点数兑换不能同时使用哦！Dear member, SORRY. The redeemed points should be under twice than total order PVs.',3000);
			this.$refs.arInputRef.blur()
		},
		scrollToPurchase(){
			this.showPurchaseModal = false
			const element = document.getElementById(this.mainSku);
			element.scrollIntoView({
			  behavior: 'smooth', // 平滑滚动
			  block: 'start'      // 对齐方式
			});
			// console.log(this.$refs.root)
			// this.$refs.root.scrollTop = 100
		}
	},
};
</script>

<style lang='scss' scoped>
@import "@/style/common";
@import "@/style/mixin";
.p-name1{
	//position: relative;
}
.load {
	width: 100%;
	//margin: 40px auto;
	margin-bottom: 30px;
	overflow: hidden;
	height: 350px;
	position: relative;
}
.cartPage {
	width: 78.03vw;
	margin: 40px auto;
	margin-bottom: 30px;
	overflow: hidden;
}
.warehouse {
	@include fontSize($font-size-15);
}
.selectWarehouse {
	border-radius: 0;
}
.toPc {
	margin-bottom: 40px;
	text-align: right;
	span {
		color: $theme-color;
	}
	.goto {
		text-decoration-line: underline;
		&:hover {
			text-decoration-line: underline;
		}
	}
}
.addressTitle {
	margin-top: 20px;
	margin-bottom: 10px;
	overflow: hidden;
	line-height: 30px;
	b {
		@include fontSize($font-size-16);
	}
	.addAddress {
		float: right;
		@include fontSize($font-size-14);
		border-radius: 0;
	}
}
.addressTag {
	@include fontSize($font-size-14);
}
.address {
	@include fontSize($font-size-15);
	overflow: hidden;
	.item {
		cursor: pointer;
		width: 100%;
		border: 1px solid #eee;
		padding: 20px;
		overflow: hidden;
		margin-bottom: 15px;
		&.select {
			border-color: $theme-color;
			border-width: 2px;
			&.hover {
				border-width: 2px;
			}
		}
		&.hover {
			border-color: $theme-color;
			border-width: 1px;
		}
		.left {
			float: left;
			i {
				display: inline-block;
				font-style: normal;
				@include fontSize($font-size-13);
				color: #fff;
				margin-right: 3px;
			}
		}
		.right {
			float: right;
			position: relative;
			top: 20px;
			img {
				width: 15px;
			}
		}
		.name {
		}
		.tel {
			margin-left: 20px;
			margin-right: 10px;
		}
		p {
			padding-top: 3px;
		}
	}
}
.showAllAddr {
	color: $theme-color;
	font-weight: 500;
	border-bottom: 1px solid #fff;
	display: block;
	cursor: pointer;
	@include fontSize($font-size-14);
	// margin-bottom: 20px;
}
.transition_dom {
	transition: all 0.3s linear 0s;
}
.productList {
}
.productList {
	text-align: center;
	margin: auto;
	margin-top: 20px;
	@include fontSize($font-size-14);
	.checkbox {
		width: 5%;
		white-space: nowrap;
	}
	.img {
		width: 120px;
		height: auto;
		padding: 10px;
		display: block; // height: 80px;
		min-height: 80px;
	}
	.p-img{
		width: 10%;
	}
	.p-left{
		float: left;
		margin-right: 10px;
	}
	.p-right{
		padding: 20px;
	}
	.p-checkbox {
		width:60px;
	}
	.product-header {
		font-weight:bold;
		padding:10px 0;
	}
	.p-name {
		text-align: left;
		position: relative;
		width: 40%;
		.p-name-span {
			width: 50%;
			position: relative;
			display: inline-block;
			.span_name {
				display: inline-block;
				@include fontSize($font-size-15);
			}
		}
		.exchange {
			margin-left: 30px;
			padding: 2px 4px;
			background-color: $theme-color;
			border-color: $theme-color;
			color: white;
			border-radius: 4px;
			cursor: pointer;
			&:hover {
				background-color: #c99ed3e8;
				border-color: #c99ed3e8;
			}
		}
	}
	.count,
	.sub-total,
	.sub-dh {
		width: 15%;
	}
	.price {
		width: 10%;
	}
	.sub-point{
		position: relative;
	}

	.delete {
		color: indigo;
		cursor: pointer;
		display: inline-block;
		margin-top: 5px;
	}
	.show_nostock {
		// font-weight: bold;
		@include fontSize($font-size-13);
		line-height: 24px;
		padding: 3px 5px;
		background-color: #ccc;
		color: white;
		border-radius: 5px;
		white-space: nowrap;
		em {
			font-style: normal;
		}
	}
	.show_nogiven {
		color:red;
	}
	.product {
		display:flex;
		align-items:center;
		border-bottom: 1px solid #eaeaea;
		.count{
			position: relative;
		}
		th {
			padding: 10px;
			font-weight: 500;
			@include fontSize($font-size-14);
		}
		.other {
			padding-top: 3px;
			color: #999;
			span {
				margin-right: 10px;
			}
		}
	}
}
.promote {
	background: url(../../../assets/order/address_bottom.png) left top repeat-x;
	background-size: auto 4px;
	.promote-tag {
		color: rgb(255, 70, 29);
		display: inline-block;
		font-weight: 500;
		line-height: 8.2px;
		padding: 5px;
		margin-left: 5px;
		border: 1px solid rgb(255, 70, 29);
		border-radius: 7.03px;
		margin-right: 2.34px;
	}
	.stepper {
		display:flex;
		align-items: center;
		justify-content:center;
		height: 30px;
		.sub,.add {
			color: white;
			width: 30px;
			height: 30px;
			text-align: center;
			margin: 0 8px;
			border-radius: 5px;
		}
	}
}
.nobgc {
	background:none;
}
.returninfo {
	padding-top: 2px;
	img {
		width: 20px;
		height: 20px;
		margin-right: 5px;
	}
	span {
		vertical-align: text-bottom;
		color: #bc86c9;
	}
}
.hot {
	display: inline-block; // width: 36px;
	// height: 18px;
	line-height: 18px; //margin-left: 4px;
	@include fontSize($font-size-13);
	color: #fff;
	text-align: center;
	background-color: $theme-color;
	padding: 3px 10px;
	border-radius: 10px;
	//margin: 0px 5px;
	&:first-child {
		margin-left: 0;
	}
	b {
		font-weight: 500;
		@include fontSize($font-size-12);
	}
}
.select_pt_no {
	position: absolute;
	right: 0;
	top: 43%;
	span {
		cursor: pointer;
		@include fontSize($font-size-14);
		color: #fff;
		padding: 8px;
		background-color: #ccc;
		border-radius: 15px;
		border: 1px solid #ccc;
		div {
			display: inline;
		}
	}
}
.hotlist {
	margin-top: 5px;
	margin-bottom: 5px;
}
.gather {
	padding: 20px 0px;
	margin-bottom: 10px;
	margin-top: 10px;
	position: relative;
	min-height: 300px;
	.gather-left {
		width: 33vw;
		display: inline-block;
	}
	.element {
		position: relative;
		margin-bottom: 15px;
		@include fontSize($font-size-15);
		&.lrpt-text .value {
			// display: inline-block;
			// text-align: left;
			// width: 100%;
			width: inherit;
		}
		&.merge {
			.name {
				color: $theme-color;
				text-align: left;
			
			}
			.tip-doubt {
				position: relative;
				top: -10px;
				margin: 0;
			}
			b {
				display: inline;
				@include fontSize($font-size-16);
			}
		}
	}
	.tip-doubt {
		width: $font-size-12;
		position: absolute;
		margin-left: 5px; // top: -3px;
		// left: 5px;
	}
	.total-pv,
	.total-fee,
	.ar {
		.name {
			cursor: pointer;
		}
	}
	.ar {
		//height: 45px;
		//margin-bottom: 15px;
	}
	.balance {
		//height: 45px;
		//margin-bottom: 20px;
	}
	.lapsePv .value {
	}
	.lapseMore {
		color: $theme-color;
	}
	.name {
		// width: 250px;
		display: inline-block;
		text-align: right;
		b {
			display: block;
			text-align: left;
			font-weight: 500;
		}
	}
	.name1 {
		width: 250px;
		display: inline-block;
		text-align: right;
	}
	.value {
		width: 90px; //display: inline-block;
		text-align: right;
		font-weight: bold;
		float: right;
		position:relative;
		.mask {
			position: absolute;
		    top: 0;
		    width: 80px;
		    background-color: rgba(0,0,0,0.2);
		    right: 0;
		    bottom: 0;
		}
	}
	.add_x {
		text-decoration: line-through;
	}
	.move_x {
		text-decoration: none;
	}
	.mdeliveryFemv {
		display: flex;
		position: absolute;
		top: -1px;
		right: 0.4rem;
		text-align: center;
		display: inline-block;
		div {
			font-size: 0.1rem;

			padding: 2px;
			border: 1px solid #666;
			border-radius: 10px; //margin-right: .1rem;
			transform: scale(1);
		}
		p {
			white-space: nowrap; //line-height: 20px;
		}
	}
	.gather-right {
		width: 20vw;
		margin-top: 20px;
		float: right;
		position: absolute;
		bottom: 20px;
		right: 0;
		button {
			// font-family: arial, "Microsoft YaHei";
			height: 56px;
			@include fontSize($font-size-16);
			font-weight: bold;
			b {
				@include fontSize($font-size-13);
				display: block;
			}
		}
		.cleanBtn,
		.gobuy {
			width: 45%;
			border-radius: 40px;
			margin-bottom: 10px;
		}
		.btnW {
			width: 10%;
			height: 56px;
			display: inline-block;
		}
		.confirm {
			border-radius: 40px;
		}
		.gobuy {
		}
	}
	.total-amount {
		//margin-top: 10px;
		//height: 40px;
		.value {
			@include fontSize($font-size-20);
			color: #a27eaa;
		}
		&.amount1 {
			margin-top: 0px;
		}
	}
}
.main-bh {
	.tip {
		@include fontSize($font-size-13);
		margin-bottom: 10px;
		color: #31384a;
	}
	.highlight {
		animation: myfirst 2s;
		animation-iteration-count: infinite;
		-webkit-animation-iteration-count: infinite; /* Safari 和 Chrome */
		color: red;
	}

	@keyframes myfirst {
		0% {
			color: #ea1414;
		}
		25% {
			color: #31384a;
		}
		50% {
			color: #ea1414;
		}
		75% {
			color: #31384a;
		}
		100% {
			color: #ea1414;
		}
	}
}
.setlrp {
	display:flex;
	align-items: center;
	img {
		margin-top: 15px;
		width:20px;
		height:20px;
	}
}
.lrp-date {
	margin-top: 15px;
	display:flex;
	align-items: center;
}

//移动版样式
@media (max-width: 768px) {
	.offset{
		margin-bottom: 2rem;
	}
	.products_add{
		position: relative;
		
	}
	.cartPage {
		width: 95.03vw;
		margin: 15px auto;
	}
	.select_pt_no span div {
		display: none;
	}
	
	.no_mobile {
		display: none;
	}
	.warehouse {
		font-size: 0.5rem;
		line-height: 30px;
	}
	.selectWarehouse {
		font-size: 0.5rem;
		float: right;
	}
	.addressTitle {
		.addAddress {
			font-size: 0.5rem;
		}
		b {
			font-size: 0.5rem;
		}
	}
	.address {
		.item {
			.left {
				font-size: 0.5rem;
			}
		}
	}
	.gather {
		min-height: auto;
		margin-bottom: 0;
		.element {
			font-size: 0.5rem;
			.mdeliveryFemv {
				div {
					font-size: 0.3rem;
				}
				top:0.1rem;
				right: 1.5rem;
			}
		}
		.gather-left {
			width: 100%;
		}
		.gather-right {
			width: 70%;
			clear: both;
			position: initial;
			float: none;
			margin: auto;

		}
		.tip-doubt{
			width: 0.5rem;
		}
		.total-amount {
			.value {
				font-size: 0.5rem;
			}
		}
	}
	.checkbox {
		white-space: nowrap;
	}
	.productList {
		.product {
			th {
				font-size: 0.5rem;
			}
			td{
				padding: 10px 0px;
			}
		}
		.price {
			width: 15%;
			font-size: 0.5rem;
		}
		.img {
			width: 2rem;
			min-height: 2rem;
			padding: 0;
			display: initial;
			margin-right: 5px;
		}
		.p-name {
			padding-top: 5px;
			padding-bottom: 5px;
			.p-name-span {
				width: initial;
				> span {
					font-size: 0.5rem;
				}
				.span_name {
					font-size: 0.5rem;
				}
			}
		}
	}
	.promote {
		background-size: auto 2px;
	}
	.returninfo img {
		width: 15px;
		height: 15px;
	}
	.point_mobile {
		position: relative;
		.select_pt_no {
			position: initial;
			margin-top: 10px;
		}
		.select_pt_module {
			padding: 0;
			float: initial;
			margin-top: 10px;
		}
	}
}
.products {
	.optional-product {
		cursor:pointer;
		border:1px solid #eee;
		border-radius: 10px;
		overflow: hidden;
		display:flex;
		align-items: center;
		margin-bottom: 10px;
		.radio-box {
			margin-left: 20px;
		}
		img {
			width:90px;
			height:90px;
		}
		.title {
			color:#777;
			margin-bottom: 10px;
		}
		.description {
			display: -webkit-box;
			word-break: break-all;
			-webkit-line-clamp: 2;//向显示多少行就给多大值
			-webkit-box-orient: vertical; 
			overflow: hidden;
			color:$theme-color;
			
		}
	}
}
.coupon-money {
	text-align:right;
	font-size: 16px;
	font-weight: bold;
}
.purchaseModal {
	position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(55, 55, 55, 0.6);
    height: 100%;
    z-index: 19000;
    display:flex;
    align-items: center;
    justify-content: center;

    .content {
    	margin-bottom: 200px;
    	width:400px;
    	background-color: white;
    	border-radius: 10px;
    	.main-bh {
    		padding:30px 20px;
    	}
    }
    .p-footer {
		display: flex;
		border-top: 1px solid #E8EAEC;
	}
}

</style>
